/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';

/**
 * 
 * @export
 * @interface OrganizationCreateRequest
 */
export interface OrganizationCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateRequest
     */
    name: string;
    /**
     * 
     * @type {Status}
     * @memberof OrganizationCreateRequest
     */
    status: Status;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateRequest
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateRequest
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateRequest
     */
    currencyCode: string;
}

/**
 * Check if a given object implements the OrganizationCreateRequest interface.
 */
// @ts-ignore
export function instanceOfOrganizationCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "countryCode" in value;
    isInstance = isInstance && "timezone" in value;
    isInstance = isInstance && "currencyCode" in value;

    return isInstance;
}

// @ts-ignore
export function OrganizationCreateRequestFromJSON(json: any): OrganizationCreateRequest {
    return OrganizationCreateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function OrganizationCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationCreateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'status': StatusFromJSON(json['status']),
        'countryCode': json['country_code'],
        'timezone': json['timezone'],
        'currencyCode': json['currency_code'],
    };
}

// @ts-ignore
export function OrganizationCreateRequestToJSON(value?: OrganizationCreateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'status': StatusToJSON(value.status),
        'country_code': value.countryCode,
        'timezone': value.timezone,
        'currency_code': value.currencyCode,
    };
}

